<!-- eslint-disable vue/no-v-html -->
<template>
  <v-sheet
    :style="`overflow: scroll; max-height: 600px`"
    class="p-4 module-question-component"
  >
    <div
      v-for="(question, index) in editableQuestions"
      :key="index"
    >
      <div class="w-100 question-content">
        <div
          class="mt-2 d-flex"
        >
          <span class="text-warning">{{ index + 1 }})&nbsp;</span>
          <span v-html="question.content" />
        </div>
      </div>
      <v-radio-group
        v-model="question.user_choice_id"
        column
        :disabled="alreadySubmited"
        :readonly="alreadySubmited"
        :light="!$vuetify.theme.dark"
      >
        <v-container
          v-for="(choice,key) in question.choices.filter((o,k)=>k<=4)"
          :key="key"
          class="d-flex rounded my-2"
          :class="{
            'border': question.user_choice_id === choice.id,
            'border-success': question.hit === 1,
            'radio-success': (question.hit === 1 && alreadySubmited && question.user_choice_id === choice.id || question.correct_choice_id === choice.id && alreadySubmited),
            'radio-error border border-danger': question.hit === 0 && alreadySubmited && question.user_choice_id === choice.id,
          }"
        >
          <v-row>
            <v-col
              :cols="3"
              :md="1"
              :lg="1"
              :sm="2"
            >
              <v-radio
                :label="`${alternatives[key]}) `"
                color="warning"
                :value="choice.id"
                @click.prevent="answer(question.id, choice.id)"
              />
            </v-col>
            <v-col class="pt-3 pl-4">
              <a @click.prevent="answer(question.id, choice.id)">
                <div
                  class="choice-content-container"
                  v-html="choice.content"
                />
              </a>
            </v-col>
          </v-row>
        </v-container>
      </v-radio-group>
    </div>
    <div
      v-if="alreadySubmited"
      class="p-2"
      :class="statusClass"
    >
      {{ correctAnsweredQuestions }} acertos de {{ editableQuestions.length }} questões.
    </div>
    <div class="mb-4">
      <v-btn
        class="mb-5"
        rounded
        color="primary"
        :disabled="alreadySubmited || !isAllAnswered"
        @click="onSubmit"
      >
        {{ alreadySubmited ? 'Respondido' : 'Enviar respostas' }}
        <span v-if="!alreadySubmited"> ({{ countAnswered }} / {{ questions.length }}) </span>
        <v-icon v-if="alreadySubmited">
          fas fa-check-circle
        </v-icon>
      </v-btn>
    </div>
    <v-dialog
      v-model="showModal"
      max-width="500px"
    >
      <v-card>
        <v-card-text>
          Agora você pode verificar suas respostas. Para finalizar o conteúdo, clique em <strong>Concluir</strong>.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            @click="showModal = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>
<script>

import alternatives from "@/constants/alternatives"
import {defaultModalHeight} from "@/constants/general.js";
import timeHandlerMIxin from './timeHandlerMIxin';
import { mapGetters } from "vuex";

export default {
  mixins: [timeHandlerMIxin],
  data() {
    return {
      alternatives,
      editableQuestions: [],
      showResult: false,
      showModal: false,
      alreadySubmited:false,
      defaultModalHeight,
    }
  },
  computed: {
    ...mapGetters(['content']),
    questions(){
      return this.content.content
    },
    countAnswered() {
      const answeredQuestions = this.editableQuestions.map(a => !!a.user_choice_id);
      return answeredQuestions[0] ? answeredQuestions.length > 1 ? answeredQuestions.reduce((a, b) => a + b): 1 : 0 ;
    },
    canAnswer(){
      return  this.isAllAnswered && !this.alreadySubmited
    },
    correctAnsweredQuestions(){
      return this.editableQuestions.filter(q=>q.hit === 1).length;
    },
    isAllAnswered() {
      return this.countAnswered === this.editableQuestions.length;
    },
    statusClass(){
      return this.correctAnsweredQuestions > 8 ? 'text-success' : this.correctAnsweredQuestions < 5 ? 'text-danger' : 'text-danger' ;
    }
  },
  created() {
    this.editableQuestions = this.questions;
    this.alreadySubmited = this.isAllAnswered ? true: false
  },
  methods: {
    answer(questionId, choiceId) {
      this.editableQuestions = this.editableQuestions.map(q => {
        if (q.id === questionId) {
          q.answered = choiceId
        }
        return q;
      })
    },
    onSubmit(){
        axios.post("/api/v1/student/question/answer", {
          answers: this.editableQuestions.map(q=> {
            return {
              question_id: q.id,
              choice_id: q.answered,
            }
          })
        }).then((r) => {

            this.editableQuestions = this.editableQuestions.map((q,i) =>{
              q.hit = r.data.data[i].hit
              q.correct_choice_id = r.data.data[i].correct_choice_id
              return q
            })
            this.alreadySubmited = true
            this.showModal = true
          }
        )
    },
  }
}
</script>
<style lang="scss">
.module-question-component{
  .v-radio > .v-label {
    margin-left: 3px;
    margin-top: 4px;
  }
  .question-content{
    img {
      width: 100%;
      max-width: 100%;
    }
  }
}
.choice-content-container {
  p {
    margin: 0;
  }
}
.popup-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  width: 80%;
  max-width: 500px;
}
</style>
